const config = {
    country: 'DK',
    defaultZoom: 15,
    postalLength: 4,
    mapOptions: {
        center: { 'lat': 55.8667, 'lng': 10.6167 },
        zoom: 8,
        scrollwheel: true,
        streetViewControl: false,
        mapTypeControl: false
    },
    mapStyles: [
        {
            featureType: 'poi.business',
            stylers: [{visibility: 'off'}]
        }
    ],
    clusterOptions: {
        maxZoom: 13,
        styles: [
            {
                textColor: 'white',
                url: '/assets/gfx/clusterMarker40.png',
                height: 40,
                width: 40
            }
        ]
    }
};

export default config;
